<template>
  <d-container fluid class="main-content-container px-4">
    <d-row>
      <d-col lg="8" class="mx-auto mt-4">
        <d-card class="card-small edit-user-details mb-4">
          <d-card-body class="p-0">
            <!-- Nav Wrapper -->
            <div class="border-bottom clearfix d-flex">
              <d-nav tabs class="border-0 mt-auto mx-4 pt-2">
                <h5 class="card-title mt-5">Informações</h5>
                <hr />
              </d-nav>
            </div>
            <d-form class="py-4">
              <d-form-row class="mx-4">
                <d-col lg="8">
                  <d-form-row>
                    <!-- Name -->
                    <d-col md="6" class="form-group">
                      <label>Nome</label>
                      <d-input
                        type="text"
                        id="name"
                        v-model="UserInternal.Name"
                        placeholder="Nome"
                      />
                    </d-col>
                    <d-col md="6" class="form-group">
                      <label>Telefone</label>
                      <d-input-group seamless>
                        <d-input-group-text slot="prepend">
                          <i class="fas fa-phone-alt"></i>
                        </d-input-group-text>
                        <the-mask
                          class="form-control"
                          type="tel"
                          placeholder="Telefone"
                          :mask="['(##) ####-####', '(##) #####-####']"
                          v-model="UserInternal.Phone"
                        />
                      </d-input-group>
                    </d-col>
                  </d-form-row>
                  <d-form-row>
                    <!-- Email -->
                    <d-col md="12" class="form-group">
                      <label for="lastName">Email</label>
                      <d-input type="email" id="email" readonly v-bind:value="UserInternal.Email" />
                    </d-col>
                  </d-form-row>
                </d-col>
                <!-- User Profile Picture -->
                <d-col lg="4">
                  <label for="userProfilePicture" class="text-center w-100 mb-4">Imagem do Perfil</label>
                  <div class="edit-user-details__avatar m-auto">
                    <img
                      alt="Avatar do Usuário"
                      :key="hasChangedImage"
                      :src="UserInternal.PictureUrl"
                      id="imgUser"
                    />
                    <label class="edit-user-details__avatar__change">
                      <i class="material-icons mr-1">&#xE439;</i>
                      <b-form-file
                        accept="image/*"
                        type="file"
                        @change="ChangeProfileImage($event)"
                        id="userProfilePicture"
                        class="d-none"
                      />
                    </label>
                  </div>
                  <legend id="legendChangeImg">Clique na imagem para alterar a foto</legend>
                </d-col>
              </d-form-row>
            </d-form>
          </d-card-body>

          <!-- Save Changes -->
          <d-card-footer class="border-top">
            <d-button
              size="sm"
              v-on:click.stop="ProcessChanges()"
              :disabled="loading"
              class="btn-accent ml-auto d-table mr-3"
            >
              <template v-if="!loading">Salvar</template>
              <template v-else>
                <loader :small="true" :isLoading="loading"></loader>
              </template>
            </d-button>
          </d-card-footer>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import TagsInput from "@johmun/vue-tags-input";
import "@/assets/scss/vue-tags-input.scss";
import { FileToBase64 } from "../../utils/fileUtils.js";
export default {
  name: "user-profile",
  components: {
    TagsInput
  },
  data() {
    return {
      hasChangedImage: 0,
      loading: false,
      PictureFile: null,
      promises: [],
      resolveDict: {},
      UserInternal: {
        Name: null,
        Email: null,
        Phone: null,
        PictureUrl: null
      }
    };
  },
  methods: {
    ProcessChanges() {
      this.loading = true;
      const OldUserData = this.$getUserInternal();
      if (
        this.UserInternal.Name != OldUserData.Name ||
        this.UserInternal.Phone != OldUserData.Phone ||
        this.hasChangedImage != 0
      ) {
        this.ChangeProfileInfo(this.hasChangedImage != 0);
      } else {
        this.$makeToast(
          "Você não alterou nenhuma informação",
          "warning",
          "Ops"
        );
        this.loading = false;
      }
      // TODO: Wait all axios requests complete to change "loading" state to false.
      // Can be done using promises.
    },
    generatePromise(item) {
      let prom = new Promise(resolve => {
        this.resolveDict[item] = resolve;
      });
      this.promises.push(prom);
    },
    ChangeProfileImage(event) {
      const file = event.target.files[0];
      if (file != null) {
        if (file.size / 1024 > 1024) {
          this.$makeToast(
            "O tamanho máximo permitido para imagem é 1 MB",
            "danger",
            "Tamanho máximo excedido"
          );
          return;
        }
        FileToBase64(file)
          .then(image => {
            if (image.startsWith("data:image")) {
              this.UserInternal.PictureUrl = image;
              this.hasChangedImage += 1;
              this.PictureFile = file;
            } else {
              this.$makeToast(
                "O arquivo selecionado não é uma imagem válida",
                "danger",
                "Falha ao carregar a imagem"
              );
            }
          })
          .catch(error => {
            this.$makeToast(
              undefined,
              "danger",
              "Falha ao alterar a imagem",
              error
            );
          });
      }
    },
    ChangeProfileInfo(hasImgChanged) {
      let userNow = JSON.parse(JSON.stringify(this.UserInternal));
      delete userNow.PictureUrl;
      // Generate a FormData with user object.
      var formData = this.GetFormData(userNow);
      if (hasImgChanged) {
        formData.append("Image", this.PictureFile, this.PictureFile.name);
      }
      this.$store
        .dispatch("UpdateUserInternalProfile", formData)
        .then(response => {
          this.$setUserInternal(response);
          this.$root.$emit("UpdateUserInfoHeader");
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao atualizar as informações",
            error
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    GetFormData(object) {
      let formData = new FormData();
      Object.keys(object).forEach(key => formData.append(key, object[key]));
      return formData;
    },
    GetUserData: function() {
      if (this.$getUserInternal()) this.UserInternal = this.$getUserInternal();

      if (!this.UserInternal.PictureUrl)
        this.UserInternal.PictureUrl = require("@/assets/images/avatars/user.png");
      else
        this.UserInternal.PictureUrl = this.UserInternal.PictureUrl + `?${Math.random()}`
      if (!this.UserInternal.Name) this.UserInternal.Name = "Usuário Safe2Pay";
      if (!this.UserInternal.Email)
        this.UserInternal.Email = "usuario@safe2pay.com.br";
    }
  },
  beforeMount() {
    this.GetUserData();
  }
};
</script>

<style>
#imgUser {
  height: 120px;
  width: 120px;
}
#legendChangeImg {
  margin-top: 5px;
  font-size: 0.7em;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/userProfile.vue